import React from 'react';
import { I18nProvider } from 'modules/shared-i18n';
import { SubRouterProps } from '../../../shared/types';
import { Router } from './components';

// Point d'entrée du module espace perso
const EspacePerso: React.FC<SubRouterProps> = ({ sourceStructureNode, navigationTree }: SubRouterProps) => {
    return (
        <I18nProvider>
            <Router navigationTree={navigationTree} sourceStructureNode={sourceStructureNode} />
        </I18nProvider>
    );
};

export default EspacePerso;
